import React from "react";
import { useSelector } from "react-redux";
import { convertUtcToTime } from "../../../utilities/helper";
import Emptystate from "../emptystate/emptystate";
import Spinner from "../spinner/spinner";
import classes from "../TodaysEvent/todaysEvent.module.css";

const TodaysEvent = () => {
   const {
      events: { eventResponse, getLoading },
   } = useSelector((state) => state);

   const mapThroughEvents = (events) =>
      events.map((event) => (
         <>
            <div className={classes.event} key={event.id}>
               <div className={classes.imgContainer}>
                  <img src={event.eventImageUrl} alt="" />
               </div>
               <div className={classes.aboutEvent}>
                  <h6>{event.eventTitle}</h6>
                  <div
                     dangerouslySetInnerHTML={{
                        __html: event.eventDescription,
                     }}
                  ></div>
                  <h6>
                     {" "}
                     {convertUtcToTime(event?.time?.split(" - ")[0])} -{" "}
                     {convertUtcToTime(event?.time?.split(" - ")[1])}
                  </h6>
               </div>
            </div>
         </>
      ));

   return (
      <div className={classes.container}>
         {getLoading && <Spinner styleClass={classes.emptyState} />}
         {!getLoading &&
            (eventResponse.content && eventResponse.content.length > 0 ? (
               mapThroughEvents(eventResponse.content)
            ) : (
               <Emptystate styleClass={classes.emptyState} name="event" />
            ))}
      </div>
   );
};

export default TodaysEvent;
